import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServiceCoveragePage from './pages/ServiceCoveragePage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import CancellationPolicyPage from './pages/CancellationPolicyPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/about" element={<AboutPage data-id="element-8" />} data-id="element-7" />
            <Route path="/service-coverage" element={<ServiceCoveragePage data-id="element-10" />} data-id="element-9" />
            <Route path="/contact" element={<ContactPage data-id="element-12" />} data-id="element-11" />
            <Route path="/faq" element={<FAQPage data-id="element-14" />} data-id="element-13" />
            <Route path="/cancellation-policy" element={<CancellationPolicyPage data-id="element-16" />} data-id="element-15" />
            <Route path="/refund-policy" element={<RefundPolicyPage data-id="element-18" />} data-id="element-17" />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-20" />} data-id="element-19" />
            <Route path="/terms-conditions" element={<TermsConditionsPage data-id="element-22" />} data-id="element-21" />
          </Routes>
        </main>
        <Footer data-id="element-23" />
      </div>
    </Router>;
}